(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-us"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // 表单初始化
    function initContactUsForm(section) {
      const form = section.querySelector('.contact-us-form__form');
      if (!form) return;

      const formId = form.dataset.formId;
      const typeSelect = form.querySelector('[name="business_type"]');
      const orderNoField = form.querySelector('.contact-us-form__field--order-no');
      const orderNoInput = form.querySelector('[name="order_no"]');
      const submitBtn = form.querySelector('.contact-us-form__button');
      const btnText = submitBtn.querySelector('.contact-us-form__button-text');
      const btnLoading = submitBtn.querySelector('.contact-us-form__button-loading');
      const successMsg = section.querySelector('.contact-us-form__message--success');
      const errorMsg = section.querySelector('.contact-us-form__message--error');

      // API配置
      const apiEnvironment = section.dataset.apiEnvironment;
      const apiUrlProduction = section.dataset.apiUrlProduction;
      const apiUrlTest = section.dataset.apiUrlTest;
      const brandId = section.dataset.brandId;
      const websiteId = section.dataset.websiteId;

      const apiBaseUrl = apiEnvironment === 'production' ? apiUrlProduction : apiUrlTest;

      // 根据类型显示/隐藏订单号
      function toggleOrderNoField() {
        const isAfterSales = typeSelect.value === '1';
        orderNoField.style.display = isAfterSales ? 'block' : 'none';
        orderNoInput.required = isAfterSales;
        if (!isAfterSales) {
          orderNoInput.value = '';
          orderNoInput.classList.remove('error');
        }
      }

      typeSelect.addEventListener('change', toggleOrderNoField);
      toggleOrderNoField();

      // 邮箱验证
      function isValidEmail(email) {
        const pattern = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
        return pattern.test(email);
      }

      // 订单号验证
      function isValidOrderNo(orderNo) {
        // Amazon: 000-0000000-0000000
        // Walmart: 0000000000000 (13位)
        // Shopify: #ATARNI0000
        const pattern = /^(\d{3}-\d{7}-\d{7})$|^(\d{13})$|^(#[A-Za-z]*\d{4,6})$/;
        return pattern.test(orderNo);
      }

      // 获取平台ID
      function getPlatformID(orderNo) {
        if (/^(\d{3}-\d{7}-\d{7})$/.test(orderNo)) return 1; // Amazon
        if (/^(\d{13})$/.test(orderNo)) return 2; // Walmart
        if (/^(#[A-Za-z]*\d{4,6})$/.test(orderNo)) return 3; // Shopify
        return 0;
      }

      // 显示消息
      function showMessage(type, text) {
        successMsg.style.display = 'none';
        errorMsg.style.display = 'none';

        if (type === 'success') {
          successMsg.style.display = 'flex';
        } else {
          errorMsg.querySelector('.contact-us-form__message-text').textContent = text;
          errorMsg.style.display = 'flex';
        }

        // 滚动到消息
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      // 隐藏消息
      function hideMessages() {
        successMsg.style.display = 'none';
        errorMsg.style.display = 'none';
      }

      // 设置加载状态
      function setLoading(loading) {
        submitBtn.disabled = loading;
        btnText.style.display = loading ? 'none' : 'inline';
        btnLoading.style.display = loading ? 'inline-flex' : 'none';
      }

      // 表单验证
      function validateForm(formData) {
        const errors = [];

        if (!formData.name.trim()) {
          errors.push('Name is required.');
        }

        if (!formData.email.trim()) {
          errors.push('Email is required.');
        } else if (!isValidEmail(formData.email)) {
          errors.push('Please enter a valid email address.');
        }

        if (formData.business_type === '1') {
          if (!formData.order_no.trim()) {
            errors.push('Order number is required.');
          } else if (!isValidOrderNo(formData.order_no)) {
            errors.push('Incorrect order number format.');
          }
        }

        if (!formData.content.trim()) {
          errors.push('Comment is required.');
        }

        return errors;
      }

      // 表单提交
      form.addEventListener('submit', async function(e) {
        e.preventDefault();
        hideMessages();

        const formData = {
          business_type: typeSelect.value,
          name: form.querySelector('[name="name"]').value,
          email: form.querySelector('[name="email"]').value,
          order_no: orderNoInput.value,
          content: form.querySelector('[name="content"]').value,
          title: 'Customer Message'
        };

        // 验证
        const errors = validateForm(formData);
        if (errors.length > 0) {
          showMessage('error', errors[0]);
          return;
        }

        setLoading(true);

        try {
          // 处理内容格式
          const newContent = formData.content
            .replace(/\n/g, '<br/>')
            .replace(/\s/g, '&nbsp;');

          let apiUrl;
          let requestData;

          // 根据类型选择API端点
          if (formData.business_type === '1') {
            // 售后问题
            apiUrl = apiBaseUrl + 'api/site/order/contactQuestion';
            requestData = {
              name: formData.name,
              email: formData.email,
              order_no: formData.order_no,
              content: newContent,
              title: formData.title,
              platform_id: getPlatformID(formData.order_no),
              source_brand_id: brandId,
              office_website_id: websiteId
            };
          } else {
            // 批发或其他
            apiUrl = apiBaseUrl + 'api/site/email/email';
            requestData = {
              name: formData.name,
              email: formData.email,
              content: newContent,
              title: newContent,
              business_type: formData.business_type,
              source_brand_id: brandId,
              office_website_id: websiteId
            };
          }

          const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestData)
          });

          if (response.ok) {
            // HTTP 200 即为成功
            // 保存用户信息到localStorage
            try {
              localStorage.setItem('user_email', formData.email);
              localStorage.setItem('user_name', formData.name);
            } catch (e) {}

            showMessage('success');
            form.reset();
            toggleOrderNoField();
          } else {
            // 尝试解析错误信息
            let errorText = 'Submission failed. Please try again.';
            try {
              const result = await response.json();
              errorText = result.error || result.message || errorText;
            } catch (e) {}
            showMessage('error', errorText);
          }
        } catch (error) {
          console.error('Contact form error:', error);
          showMessage('error', 'Network error. Please check your connection and try again.');
        } finally {
          setLoading(false);
        }
      });

      // 从localStorage恢复用户信息
      try {
        const savedName = localStorage.getItem('user_name');
        const savedEmail = localStorage.getItem('user_email');
        if (savedName) form.querySelector('[name="name"]').value = savedName;
        if (savedEmail) form.querySelector('[name="email"]').value = savedEmail;
      } catch (e) {}
    }

    // 初始化所有联系表单
    document.querySelectorAll('.contact-us-section').forEach(initContactUsForm);

    // Shopify编辑器支持
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        if (event.target.querySelector('.contact-us-section')) {
          initContactUsForm(event.target.querySelector('.contact-us-section'));
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
